import React, { useState } from 'react';
import { Table, Button, Popconfirm, Space, Modal, Tag } from 'antd';
import { useCurrency } from '../../store/currencyContext';
import CurrencyForm from './CurrencyForm';
import { Currency } from '../../api/currencyApi';
import { useTranslation } from 'react-i18next';
import PageNavigation from '../Layout/PageNavigation';

const CurrencyList: React.FC = () => {
    const { t } = useTranslation();
    const { currencies, loading, createCurrency, updateCurrency, deleteCurrency } = useCurrency();
    const [editingCurrency, setEditingCurrency] = useState<Currency | null>(null);
    const [open, setOpen] = useState(false);

    const handleEdit = (record: Currency) => {
        setEditingCurrency(record);
        setOpen(true);
    };

    const handleCreate = () => {
        setEditingCurrency(null);
        setOpen(true);
    };

    const handleSubmit = async (values: Currency) => {
        if (editingCurrency && (editingCurrency.id as string)) {
            await updateCurrency((editingCurrency.id as string), values);
        } else {
            await createCurrency(values);
        }
        setOpen(false);
    };

    const columns = [
        { title: t('currency_code'), dataIndex: 'code', key: 'code' },
        { title: t('symbol'), dataIndex: 'symbol', key: 'symbol' },
        { title: t('rate_to_iqd'), dataIndex: 'rateToIQD', key: 'rateToIQD' },
        {
            title: t('default'),
            dataIndex: 'isDefault',
            key: 'isDefault',
            render: (isDefault: boolean) =>
                isDefault ? <Tag color="green">{t('default')}</Tag> : <Tag>--</Tag>
        },
        {
            title: t('actions'),
            key: 'actions',
            render: (_: any, record: Currency) => (
                <Space>
                    <Button type="primary" onClick={() => handleEdit(record)}>{t('edit')}</Button>
                    <Popconfirm title={t('are_you_sure')} onConfirm={() => deleteCurrency((record.id || record.id) as string)}>
                        <Button type="primary" danger>{t('delete')}</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return (
        <>
            <PageNavigation title={t('currencies') as string} />
            <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
                {t('add_currency')}
            </Button>
            <Table
                rowKey={record => record.id as string}
                columns={columns}
                dataSource={currencies}
                loading={loading}
            />
            <Modal
                title={editingCurrency ? t('edit_currency') : t('add_currency')}
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                destroyOnClose
                width={500}
            >
                <CurrencyForm
                    initialValues={editingCurrency ?? undefined}
                    onFinish={handleSubmit}
                    loading={loading}
                />
            </Modal>
        </>
    );
};

export default CurrencyList;